import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SEOService {
  constructor(private readonly title: Title, private readonly meta: Meta) {}

  setPageTitle(value: string | null, isDelete: boolean = false) {
    if (isDelete) {
      this.title.setTitle(`${environment.websiteTitle}`);
    }
    if (value) {
      this.title.setTitle(`${value}`);
    }
  }

  setMetaTagDescription(value: string | null, isDelete: boolean = false) {
    if (isDelete) {
      this.meta.removeTag('name="description"');
      this.meta.removeTag('property="og:description"');
    }
    if (value) this.meta.updateTag({ name: 'description', content: value });
  }

  setMetaTagKeywords(value: string | null, isDelete: boolean = false) {
    if (isDelete) {
      this.meta.removeTag('name="keywords"');
      this.meta.removeTag('property="og:keywords"');
    }
    if (value) this.meta.updateTag({ name: 'keywords', content: value });
  }

  removeAllMetaTags() {
    this.setPageTitle(null, true);
    this.setMetaTagKeywords(null, true);
    this.setMetaTagDescription(null, true);
  }
}
